export default __webpack_public_path__ + "static/media/account_circle_blue.cdaddf27.svg";